import React, {useEffect, useState} from "react";
import {DatePicker, message, PageHeader, Select, Space, Table, Input, Dropdown, Menu, Button} from "antd";
import moment from "moment";
import {apiClient} from "../../../services/ApiClient";
import {PaymentProvider, PaymentMethod} from "../../common/AppEnums";
import UpdateButton from "../../buttons/UpdateButton";
import numeral from "numeral";
import {
  DownOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";

const { Option } = Select;
const { RangePicker } = DatePicker;
const {Search} = Input;

const CMD_EXPORT = "export";

export default function DriverDebitsPage() {
  let [records, setRecords] = useState([]);
  let [recordsTotal, setRecordsTotal] = useState(0);
  let [loading, setLoading] = useState(false);
  let [recordsStamp, setRecordsStamp] = useState(0);
  let [transactionsFilter, setTransactionsFilter] = useState({type: ''});
  let [drivers, setDrivers] = useState([]);
  let [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    position: 'topRight',
    defaultPageSize: 50,
    pageSizeOptions: [50, 100, 200, 300]
  });
  let [sorter, setSorter] = useState({});
  let [selectedRows, setSelectedRows] = useState([]);
  let [transactionGroups, setTransactionGroups] = useState([]);
  let [transactionStatuses, setTransactionStatuses] = useState([]);

  useEffect(() => {
    apiClient.searchDirectoryRecord('taxiDriver', '')
      .then(res => {
        setDrivers(res.records);
      })
      .catch(err => {
        message.error(err);
      });
    apiClient.searchDirectoryRecord('transactionStatus', '')
      .then(res => {
        setTransactionStatuses(res.records);
      })
      .catch(err => {
        message.error(err);
      });
    apiClient.getTransactionGroups({transaction_type: 'debit'})
      .then(res => {
        setTransactionGroups(res.records);
      })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    setLoading(true);
    let filter = {
      type: "debit",
      categories: ['crm_manual_operation', 'crm_auto_operation', 'crm_form_operation'],
      sortField: sorter.field,
      sortOrder: sorter.order,
      status: transactionsFilter.status,
      vehicleNumber: transactionsFilter.vehicleNumber,
      driver: transactionsFilter.driver,
      group: transactionsFilter.group,
      page: pagination.current,
      pageSize: pagination.pageSize,
    };
    if(transactionsFilter.period && transactionsFilter.period.length > 0) {
      filter.from = moment(transactionsFilter.period[0]).format('YYYY-MM-DD');
      filter.to = moment(transactionsFilter.period[1]).format('YYYY-MM-DD');
    }
    apiClient.getDriverTransactions(filter)
      .then(res => {
        setRecordsTotal(res.total);
        setRecords(res.records);
        setPagination(prevState => {return {...prevState, total: res.total}})
      })
      .catch(err => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [recordsStamp, transactionsFilter]);

  const columns = [
    {
      title: "",
      align: "center",
      width: 30,
    },
    Table.SELECTION_COLUMN,
    {
      title: 'Дата',
      dataIndex: 'create_dt',
      align: "center",
      width: 200,
      render: (text, record, index) => {
        return `${moment(record.create_dt).format('DD.MM.YYYY HH:mm')}`;
      },
      sorter: true,
      defaultSortOrder: 'descend',
    },
    {
      title: "Водитель",
      width: 250,
      render: (text, record, index) => {
        return record.driver_details?.name;
      },
    },
    {
      title: "Рег.номер",
      dataIndex: "driver_rent_details",
      align: "center",
      width: 120,
      render: (text, record, index) => {
        return record.driver_rent_details?.reg_number;
      },
    },
    {
      title: "Сумма",
      dataIndex: "amount",
      align: "center",
      width: 180,
      render: (text, record, index) => {
        return numeral(record.amount).format('0.00')
      },
      sorter: true,
    },
    {
      title: "Группа",
      dataIndex: "payment_group",
      align: "center",
      width: 180,
      render: (text, record, index) => {
        return transactionGroups.find(el => el.id == record.payment_group_id)?.title || "";
      },
    },
    {
      title: "Комментарий",
      width: 300,
      dataIndex: "comment",
    },
    {
      title: "Статус",
      dataIndex: "status",
      align: "center",
      width: 200,
      render: (text, record, index) => {
        return transactionStatuses.find(el => el.id == record.processing_status)?.title || record.processing_status;
      },
    },
    {
      title: "",
      align: "center",
      width: 20,
    }
  ];

  const executeSelectedRecordsOperation = key => {
    if(key === CMD_EXPORT) {
      // apiClient.getDriverPaymentsExport(selectedRows.map(el => el.id))
      //   .then(res => {
      //     window.open(res.link);
      //     setSelectedRows([]);
      //   })
      //   .catch(err => message.error(err));
    }
  };

  return (
    <>
      <PageHeader
        className="site-page-header"
        title="Списания"
        extra={
          (
            <div style={{textAlign: "right"}}>
              <Space direction={"vertical"} size={"small"}>
                <span>Сумма: {numeral(selectedRows.map(el => parseFloat(el.amount)).reduce((a, b) => a + b, 0)).format('0.00')} руб.</span>
                <span>{`Всего записей: ${recordsTotal}`}</span>
              </Space>
            </div>
          )
        }
      />
      <div style={{width: '100%'}}>
        <div style={{width: '80%', float: 'left', marginBottom: 40}}>
          <Space direction={"horizontal"} wrap>
            <Select
              showSearch
              allowClear
              style={{ width: 350 }}
              placeholder="Водитель"
              onChange={(value) => {
                setTransactionsFilter({...transactionsFilter, ...{driver: value}});
                setPagination({...pagination, current: 1})
              }}
              filterOption={(input, option) => {
                return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
              }}
            >
              {drivers.map(s => <Option key={s.id} value={s.id}>{`${s.last_name} ${s.first_name} ${s.middle_name} (${s.phone})`}</Option>)}
            </Select>
            <Search
              enterButton
              placeholder={"Поиск по гос.номеру"}
              onSearch={(value) => {
                setTransactionsFilter({...transactionsFilter, ...{vehicleNumber: value}});
                setPagination({...pagination, current: 1});
              }}
              allowClear={true}
              style={{width: 300}}
            />
            <RangePicker format="DD.MM.YYYY" style={{width: 350}} onChange={(val) => {
              setTransactionsFilter({...transactionsFilter, ...{period: val}});
              setPagination({...pagination, current: 1});
            }}/>
            <Select
              showSearch
              allowClear
              style={{ width: 250 }}
              placeholder="Статус"
              onChange={(value) => {
                setTransactionsFilter({...transactionsFilter, ...{status: value}});
                setPagination({...pagination, current: 1})
              }}
              filterOption={(input, option) => {
                return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
              }}
            >
              {
                [
                  {id: "success", title: "Зачислен"},
                  {id: "failed", title: "Ошибка"},
                  {id: "processing_failed", title: "Ошибка процессинга"},
                ].map(el => <Option key={el.id} value={el.id}>{el.title}</Option>)
              }
            </Select>
            <Select
              showSearch
              allowClear
              style={{ width: 400 }}
              placeholder="Группа"
              onChange={(value) => {
                setTransactionsFilter({...transactionsFilter, ...{group: value}});
                setPagination({...pagination, current: 1})
              }}
              filterOption={(input, option) => {
                return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
              }}
            >
              {
                transactionGroups.map(el => <Option key={el.id} value={el.id}>{`${el.title} (${el.transaction_type === "debit" ? "Списание" : "Зачисление"})`}</Option>)
              }
            </Select>
          </Space>
        </div>
        <div style={{width: '20%', float: 'right'}}>
          <Space style={{float: "right"}}>
            <UpdateButton onClick={ () => setRecordsStamp(prevState => prevState + 1) }/>
            {
              selectedRows.length > 0
                ? (
                  <>
                    <Dropdown
                      overlay={(
                        <Menu onClick={(e) => {
                          executeSelectedRecordsOperation(e.key);
                        }}>
                          <Menu.Item key={CMD_EXPORT} icon={<FileExcelOutlined/>}>
                            Выгрузка в Excel
                          </Menu.Item>
                        </Menu>
                      )}>
                      <Button style={{textAlign: "left"}}>
                        С выбранными <DownOutlined/>
                      </Button>
                    </Dropdown>
                  </>
                ) : null
            }
          </Space>
        </div>
      </div>

      <Table
        dataSource={records}
        columns={columns}
        size="small"
        sticky
        style={{margin: '10px 0', marginTop: 40}}
        rowKey="id"
        loading={loading}
        pagination={pagination}
        scroll={{x: 1500}}
        onChange={(pagination, filters, sorter) => {
          setPagination(pagination);
          setSorter(sorter);
          setRecordsStamp(prevState => prevState + 1)
        }}
        rowSelection={{
          onChange: (selectedRowKeys, selectedRows) => {
            console.log(selectedRows);
            setSelectedRows(selectedRows);
          },
          selectedRowKeys: selectedRows.map(el => el.id)
        }}
      />
    </>
  );
}